import { useState } from "react";
import { http, toastApiError } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { toast } from "../../lib/notify";
import { CalendarClock, X } from "lucide-react";

const inp = "px-2 py-1 text-[11px] border border-slate-300 rounded-md bg-white";

// Kalan taksitleri 1–3 ay ertele: ay seçimi + zorunlu gerekçe (kredi açıklamasına eklenir)
export function PostponePanel({ loan, onDone }) {
  const [open, setOpen] = useState(false);
  const [months, setMonths] = useState(1);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const left = loan.schedule.filter((s) => !s.paid).length;
  const run = async () => {
    if (!reason.trim()) return toast.error("Erteleme gerekçesi girin");
    if (!window.confirm(`${[loan.bank, loan.loan_no].filter(Boolean).join(" ")} kredisinin ödenmemiş ${left} taksiti ${months} ay ileri kaydırılacak (tutarlar değişmez, kredi vadesi güncellenir, gerekçe erteleme geçmişine eklenir). Devam edilsin mi?`)) return;
    setBusy(true);
    try {
      const { data } = await http.post(`/bank-loans/${loan.id}/installments/postpone`, { months, reason: reason.trim() });
      toast.success(`${data.moved} taksit ${months} ay ertelendi — yeni vade ${fmtDate(data.due_date)} (gerekçe erteleme geçmişine yazıldı)`);
      setOpen(false); setReason(""); setMonths(1); onDone();
    } catch (e) { toastApiError(e); } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid={`loan-postpone-${loan.id}`} title="Ödenmemiş tüm taksitleri 1–3 ay ileri kaydır"
        className="ml-auto inline-flex items-center gap-1 px-2 py-1 rounded-md border border-amber-400 bg-amber-50 text-amber-900 text-[11px] font-semibold hover:bg-amber-100">
        <CalendarClock className="w-3 h-3" /> Kalan Taksitleri Ertele
      </button>
    );
  }
  return (
    <div className="ml-auto flex items-center gap-1.5 flex-wrap bg-white border border-amber-300 rounded-md px-2 py-1.5" data-testid={`loan-postpone-panel-${loan.id}`}>
      <span className="text-[11px] font-semibold text-slate-700">{left} taksiti</span>
      <select value={months} onChange={(e) => setMonths(Number(e.target.value))} data-testid={`loan-postpone-months-${loan.id}`} className={inp}>
        {[1, 2, 3].map((m) => <option key={m} value={m}>{m} ay</option>)}
      </select>
      <span className="text-[11px] text-slate-600">ertele —</span>
      <input value={reason} onChange={(e) => setReason(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); run(); } }} placeholder="Gerekçe (zorunlu)" data-testid={`loan-postpone-reason-${loan.id}`} className={`${inp} w-56`} autoFocus />
      <button type="button" disabled={busy} onClick={run} data-testid={`loan-postpone-confirm-${loan.id}`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-amber-600 text-white text-[11px] font-semibold hover:bg-amber-700 disabled:opacity-50"><CalendarClock className="w-3 h-3" /> Ertele</button>
      <button type="button" onClick={() => { setOpen(false); setReason(""); }} data-testid={`loan-postpone-cancel-${loan.id}`} className="p-1 text-slate-500 hover:text-slate-800" title="Vazgeç"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
}
